<template>
    <div>
        <div class="container">
            <h1>Kariéra</h1>
            <div class="sluzby-wrapper">
                <ul class="sluzby-list">
                    <li 
                        v-for="pozice in poziceArr" 
                        :key="pozice.id"
                        :class="(pozice.disabled) ? 'disabled' : ''"
                        @click="(pozice.disabled) ? false : openSidePage(pozice.id)"
                    >
                        <div class="sluzby-list-item">
                            <span class="sluzby-list-title">{{ pozice.name }}</span>
                            <span class="tag-pripravujeme-container" v-if="pozice.disabled">
                                <span  class="tag-pripravujeme">Připravujeme</span>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <SidePage ref="sidePageComponent">
            <Programator v-if="aktivniPoziceId === 1" />
            <SocialMediaSpecialist v-if="aktivniPoziceId === 2" />
        </SidePage>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from '../Footer.vue';
import SidePage from '../SidePage.vue';
import Programator from './Programator.vue';
import SocialMediaSpecialist from './SocialMediaSpecialist.vue';
    export default {
        components: {
            Footer, SidePage, Programator, SocialMediaSpecialist
        },
        methods: {
            openSidePage(id) {
                this.aktivniPoziceId = id;
                this.$refs.sidePageComponent.zobrazitSidePage();
            }
        },
        data() {
            return {
                aktivniPoziceId: null,
                poziceArr: [
                    {
                        id: 1,
                        name: "Programátor/ka",
                        disabled: false,
                    },
                    {
                        id: 2,
                        name: "Social Media Specialist(k)a",
                        disabled: false,
                    },
                    {
                        id: 3,
                        name: "Grafik/Grafička",
                        disabled: true,
                    },
                    {
                        id: 4,
                        name: "SEO specialist(k)a",
                        disabled: true,
                    },
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>
.sluzby-list{
    list-style: none;
    padding: 0px;
    margin: 0px auto;
    margin-bottom: 90px;
    li{
        color: #212529;
        width: 100%;
        border-bottom: solid 1px rgba(0, 0, 0, 0.2);
        padding: 40px 0px;
        cursor: pointer;
        .sluzby-list-item{
            display: flex;
        }
        .sluzby-list-title{
            font-size: 80px;
            font-weight: 600;
        }
        &.disabled{
            .sluzby-list-title{
                opacity: .25;
            }
            cursor:auto;
        }
    }
}
.sluzby-list-tags{
    margin-left: 20px;
    margin-top: 30px;
    display: flex;
    gap: 5px;
    .sluzby-list-tag{
        font-size: 16px;
        font-weight:600;
        line-height: 1.33;
        padding: 1px 7px;
        color: white;
        background-color: rgb(117, 0, 128);
        align-self: flex-start;
    }
}
.tag-pripravujeme-container{
    margin-left: auto;
    display: flex;
    align-items: center;
}
.tag-pripravujeme{
    font-size: 16px;
        font-weight:600;
        line-height: 1.33;
        padding: 1px 7px;
        color: white;
        background-color: rgba(170, 170, 175, 0.5);
}
#detail-sluzby-side-shadow{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(200, 200, 205, 0);
    display: none;
    backdrop-filter: blur(0px);
    // transition: background-color 1s;
    &.active{
        display: block;
        background-color: rgba(200, 200, 205, 0.5);
        backdrop-filter: blur(10px);
    }
}
.detail-sluzby{
    overflow-y: scroll;
    position: fixed;
    z-index: 10;
    top: 0px;
    right: 0px;
    width: 70vw;
    max-width: 1600px;
    height: 100vh;
    background-color: white;
    transform: translateX(100%);
    transition: all .3s;
    @media screen and (max-width: 992px) {
        width: 100vw;
    }
    // padding: 30px 90px;
    &.active{
        transform: translateX(0px);
    }
    #detail-sluzby-controls-container{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 40px;
        height: 100%;
    }
    .detail-sluzby-controls{
        position: sticky;
        top: 16px;
        margin-bottom: 16px;
        margin-top: 16px;
        padding-left: 32px;
        z-index: 100;
    }
    .detail-sluzby-close-btn{
        cursor: pointer;
    }
}

    .job-detail {
        /*
        padding: 30px;

        @media (min-width: 992px) {
            padding: 60px;
        }
        */
        padding: 92px;
        padding-right: 30%;
    }
</style>